





































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, PropSync } from 'vue-property-decorator';
import Vue2 from 'vue';
import { LMap, LTileLayer, LControl, LControlScale, LGeoJson } from 'vue2-leaflet';

import Lazy from 'vue-lazy-component';


import { LeafletMouseEvent, LatLng } from 'leaflet';
import AdresseGouvResult from '@/models/AdresseGouvResult';
import random from 'lodash/random';
import MapPopup from '@/components/prescriber/MapPopup.vue';
import LeafletPosition from '@/models/LeafletPosition';
// @ts-ignore
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
import MapModule from '@/store/MapModule';
import MarkerGPS from '@/models/MarkerGPS';
import FiltersModule from '@/store/FiltersModule';
import ListModule from '@/store/ListModule';

import FilterPopup from '@/components/prescriber/FilterPopup.vue';
const FutureTransportsPopup = () => import('@/components/prescriber/FutureTransportsPopup.vue');
const TransportLinesPopup = () => import('@/components/prescriber/TransportLinesPopup.vue');


import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MAP_PROVIDER, MAP_ATTRIBUTION } from '@/helpers/constants';


import axios from 'axios';
import { MAPBOX_TOKEN } from '@/helpers/constants';
import IsochronOptions from '@/models/IsochronOptions';
import { getAutocompletion, getProgramPrescriber } from '@/api/api'
import { LMarker, LIcon } from 'vue2-leaflet';

import { debounce } from 'lodash';

import * as L from 'leaflet';


// this part resolve an issue where the markers would not appear
// @ts-ignore
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface Bounds {
    _northEast: {
        lat: number;
        lng: number;
    };
    _southWest: {
        lat: number;
        lng: number;
    };
}

@Component({
    components: {
        LMap,
        LTileLayer,
        LControl,
        Vue2LeafletMarkercluster,
        LControlScale,
        LGeoJson,
        LMarker,
        LIcon,
        Lazy,
        FilterPopup,
        FutureTransportsPopup,
        TransportLinesPopup,
    },
})


export default class MapPrescriber extends Vue {
    @PropSync('update:fullscreen') readonly fullscreen!: boolean;
    pFullscreen: boolean | null = false;
    loading: boolean = false;
    realMarkers: any = [];
    private nativeMarkersMap: Map<number, L.Marker> = new Map();
    private denounceLayerGroup: L.LayerGroup | null = null;
    private activePopupVm: Vue2 | null = null;

    // Smart Load
    @Prop({ default: false }) readonly frozen!: boolean;

    @Watch('frozen')
    onFrozenChange(isFrozen: boolean) {
        const map = (this.$refs.map as any).mapObject;
        if (map) {
            if (isFrozen) {
                map.dragging.disable();
                map.scrollWheelZoom.disable();
                map.doubleClickZoom.disable();
                map.boxZoom.disable();
                map.keyboard.disable();
                if (map.tap) map.tap.disable();
            } else {
                map.dragging.enable();
                map.scrollWheelZoom.enable();
                map.doubleClickZoom.enable();
                map.boxZoom.enable();
                map.keyboard.enable();
                if (map.tap) map.tap.enable();
            }
        }
    }


    onMapReady() {
        MapModule.fetch();
        this.$nextTick(() => {
            if (MapModule.markers.length > 0) {
                this.realMarkers = this.markers;
                this.buildNativeMarkers();
            }
        });
    }


 

    visibleMarkers: any = [];


    isochronGeojson: object | null = null;

    
    debouncedBoundsUpdate!: Function;


    geojsonTransport: GeoJSON.FeatureCollection<GeoJSON.Geometry> | null = null;
    

    isoMarker = {
        coordinates:{
            lng: 3.8792269000000004,
            lat: 43.577768600000006,
        },
        color: 'blue'
    }

    

            updateVisibleMarkers() {
                if (!this.bounds || !this.realMarkers.length) {
                    this.visibleMarkers = this.realMarkers;
                    return;
                }
                
                const bounds = this.bounds;
                if (!bounds._southWest || !bounds._northEast) {
                    this.visibleMarkers = this.realMarkers;
                    return;
                }
                
                const padding = 0.5;
                
                this.visibleMarkers = this.realMarkers.filter((marker: any) => {
                    if (!marker.coordinates) return false;
                    
                    const lat = marker.coordinates.lat;
                    const lng = marker.coordinates.lng;
                    
                    return (
                        lat >= bounds._southWest.lat - padding &&
                        lat <= bounds._northEast.lat + padding &&
                        lng >= bounds._southWest.lng - padding &&
                        lng <= bounds._northEast.lng + padding
                    );
                });
            }


        // Options de performance pour la carte
        mapOptions = {
                preferCanvas: true,
                zoomAnimation: false,
                fadeAnimation: false,
                markerZoomAnimation: false,
                maxZoom: 16,
                minZoom: 3,
            };

        clusterOptions = {
            disableClusteringAtZoom: 14,
            maxClusterRadius: 150,
            animate: false,
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            chunkedLoading: true,
            chunkInterval: 200,
            chunkDelay: 50,
            removeOutsideVisibleBounds: true,
            iconCreateFunction: (cluster: any) => {
                const count = cluster.getChildCount();
                let size = 'small';
                if (count > 100) size = 'large';
                else if (count > 50) size = 'medium';
                
                return L.divIcon({
                    html: `<div><span>${count}</span></div>`,
                    className: `marker-cluster marker-cluster-${size}`,
                    iconSize: L.point(40, 40)
                });
            }
        };


        // Map Mode Switch
            url = MAP_PROVIDER;
            attribution = MAP_ATTRIBUTION;


            get mapInstance(): L.Map | null {
                        const ref = this.$refs.map as any;
                        if (ref && ref.mapObject) {
                        return ref.mapObject as L.Map;
                        }
                        return null;
                    }

            get denounceIds(): number[] {
                return this.denounceIdsReactive;
            }

            get clusteredMarkers(): any[] {
                if (this.denounceIds.length === 0) return this.realMarkers;
                return this.realMarkers.filter((m: any) => !this.denounceIds.includes(m.programID));
            }

            get denouncedMarkers(): any[] {
                if (this.denounceIds.length === 0) return [];
                return this.realMarkers.filter((m: any) => this.denounceIds.includes(m.programID));
            }

      


    result: any[] = [];

    transportMarkers: L.Marker[] = [];

    geoJson: any = {
    mode: "bicycle",
    duration: 25,
    address: "",              // Adresse saisie manuellement par l'utilisateur
    addressSelected: null,    // Résultat géocodé (toujours la DERNIÈRE adresse ajoutée — partagée avec les popups Transport / Itinéraire)
    }

    // ************* Multi-Isochrones (jusqu'à 3 zones comparées sur la carte) *************
    MAX_ISOCHRONES = 3;

    isochroneColors = [
        { hex: '#ef4444', name: 'Rouge' },
        { hex: '#2563eb', name: 'Bleu' },
        { hex: '#16a34a', name: 'Vert' },
    ];

    transportModes = [
        { value: 'bicycle', label: 'Vélo', icon: 'fa-bicycle' },
        { value: 'foot', label: 'À Pied', icon: 'fa-walking' },
        { value: 'car', label: 'Voiture', icon: 'fa-car' },
        { value: 'transit', label: 'Transport', icon: 'fa-bus' },
    ];

    // Entrées éditables du formulaire (une par isochrone)
    isochrones: Array<{ address: string; addressSelected: any; mode: string; duration: number }> = [
        { address: '', addressSelected: null, mode: 'bicycle', duration: 25 },
    ];

    // Isochrones réellement dessinés sur la carte
    renderedIsochrones: Array<{ geojson: any; style: object }> = [];

    // Index de la carte en cours d'édition (pour l'autocomplétion partagée)
    activeIsochroneIndex = 0;

    // Index de l'isochrone dont l'adresse est partagée avec les autres popups
    preferredIsochroneIndex = 0;

    private isochroneMarkers: (L.Marker | null)[] = [];
    private debouncedIsoSearch!: Function;


    trajetJson: any = {
    mode: "driving",
    duration: 25,
    address: this.geoJson.address,              // Adresse saisie manuellement par l'utilisateur
    addressSelected: null,    // Résultat géocodé
    addressProgramme: ""      // Adresse du programme (origine du trajet)
}



   // ************* Transport Data 

            transportFilter = {
            address: this.geoJson.address,               // the free-text address
            addressSelected: null as any,
            radius: 1,                 // in km
            modes: {
                tram: false,
                subway: false,
                RER: false,
                bus: false,
                train:  false
            }
        }


 

    

    colorx: string = '#4CAF50'; // couleur par défaut pour vélo

    addressForm: Boolean = false;
    TrajetForm: Boolean = false;
    tutoriel: Boolean = false;

    transportInFlight: Boolean = false;

    transportForm: boolean = false;
    transportErrorForm : boolean =  false;

    futureTransportsForm: boolean = false;
    geojsonFutureTransports: GeoJSON.FeatureCollection<GeoJSON.Geometry> | null = null;
    futureEndMarkers: L.Marker[] = [];
    gpeGareMarkers: L.Marker[] = [];

    @Watch('fullscreen')
    onFullscreen() {
        this.pFullscreen = this.fullscreen;
    }

 

    @Watch('pFullscreen')
    onPFullscreen() {
        this.$emit('update:fullscreen', this.pFullscreen);
        // @ts-ignore
        this.$refs.map.mapObject._onResize();
    }


    async onClickAddress(itemAddress: any) {
                this.geoJson.address = itemAddress.properties.label;
                this.geoJson.addressSelected = itemAddress;
                this.transportFilter.addressSelected = itemAddress;
                this.trajetJson.addressSelected = itemAddress;
                
                // Add marker for the selected address
                const [lon, lat] = itemAddress.geometry.coordinates;
                this.addAddressMarker([lon, lat], itemAddress.properties.label);
            }

            // Update onClickTrajetAddress method
            async onClickTrajetAddress(itemAddress: any) {
                this.geoJson.address = itemAddress.properties.label;
                this.trajetJson.addressSelected = itemAddress;
                this.geoJson.addressSelected = itemAddress;
                this.transportFilter.addressSelected = itemAddress;
                
                // Add marker for the selected address
                const [lon, lat] = itemAddress.geometry.coordinates;
                this.addAddressMarker([lon, lat], itemAddress.properties.label);
            }

            // Update onClickTransportAddress method
            async onClickTransportAddress(item: any) {
                this.geoJson.address = item.properties.label;
                this.transportFilter.addressSelected = item;
                this.geoJson.addressSelected = item;
                this.trajetJson.addressSelected = item;
                
                // Add marker for the selected address
                const [lon, lat] = item.geometry.coordinates;
                this.addAddressMarker([lon, lat], item.properties.label);
            }



    resultProgramme: any[] = [];

    onClickTrajetProgrammeAddress(itemAddress: any) {
        this.trajetJson.addressProgramme = itemAddress.properties.label;
        }



        async showGeoJson() {

                    if (!this.geoJson.addressSelected) return;

                    const [lon, lat] = this.geoJson.addressSelected.geometry.coordinates;
                    if (this.mapInstance) {
                        this.mapInstance.flyTo([lat, lon], 13, { duration: 1.5 });
                    }

                    this.addressForm = false;

                    // choose your “bus” factor here (0.35–0.40)
                    const BUS_FACTOR = 0.60;

                    // decide which mode & duration to pass to fetchIsochron
                    let mode   = this.geoJson.mode;
                    let duration = this.geoJson.duration;

                    if (mode === 'transit') {
                        mode = 'driving';                   // Mapbox doesn't have “bus”
                        duration = Math.max(1,              // at least 1 min
                        Math.floor(duration * BUS_FACTOR)
                        );
                    }

                    this.isochronGeojson = await this.fetchIsochron(
                        { lng: lon, lat },
                        { mode, duration }
                    );
}

            



        async showTrajetJson() {

                if (this.trajetJson.addressProgramme && this.geoJson.address) {
                    const origin = encodeURIComponent(this.trajetJson.addressProgramme);
                    const destination = encodeURIComponent(this.geoJson.address);
                    const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=${this.trajetJson.mode}`;



                    window.open(url, '_blank');
                }else {     
                    
                    this.TrajetForm = false; // 🔴 Ferme le formulaire itinéraire
                    this.tutoriel = true;     // 🟢 Affiche le tutoriel
        
            }
    }



    async deleteIsochron() {
            this.isochronGeojson = null;
            this.addressForm = false;
            this.geoJson.address = '';
            this.geoJson.addressSelected = null;

            // Remove address marker
            this.removeAddressMarker();
        }


        // ********************* Multi-Isochrones *********************

        get hasAnyIsochroneAddress(): boolean {
            return this.isochrones.some(iso => !!iso.addressSelected);
        }

        addIsochrone() {
            if (this.isochrones.length >= this.MAX_ISOCHRONES) return;
            this.isochrones.push({ address: '', addressSelected: null, mode: 'bicycle', duration: 25 });
            this.activeIsochroneIndex = this.isochrones.length - 1;
        }

        removeIsochrone(index: number) {
            if (this.isochrones.length <= 1) return;
            this.isochrones.splice(index, 1);
            if (this.activeIsochroneIndex >= this.isochrones.length) {
                this.activeIsochroneIndex = this.isochrones.length - 1;
            }
            // Adjust preferred index after removal
            if (index < this.preferredIsochroneIndex) {
                this.preferredIsochroneIndex--;
            } else if (this.preferredIsochroneIndex >= this.isochrones.length) {
                this.preferredIsochroneIndex = this.isochrones.length - 1;
            }
            // Sync shared address from new preferred iso
            const pref = this.isochrones[this.preferredIsochroneIndex];
            if (pref && pref.addressSelected) {
                this.geoJson.address = pref.address;
                this.geoJson.addressSelected = pref.addressSelected;
                this.transportFilter.addressSelected = pref.addressSelected;
                this.trajetJson.addressSelected = pref.addressSelected;
            }
            // Les couleurs/markers sont liés à l'index : on reconstruit
            this.rebuildIsochroneMarkers();
            if (this.renderedIsochrones.length) this.showIsochrones();
        }

        onIsochroneAddressInput(index: number, value?: string) {
            this.activeIsochroneIndex = index;
            const iso = this.isochrones[index];
            if (typeof value === 'string') iso.address = value;
            // L'adresse géocodée précédente n'est plus valable si le texte a changé
            if (iso.addressSelected && iso.addressSelected.properties.label !== iso.address) {
                iso.addressSelected = null;
            }
            this.debouncedIsoSearch(iso.address);
        }

        setPreferredIsochrone(index: number) {
            this.preferredIsochroneIndex = index;
            const iso = this.isochrones[index];
            if (iso.addressSelected) {
                this.geoJson.address = iso.address;
                this.geoJson.addressSelected = iso.addressSelected;
                this.transportFilter.addressSelected = iso.addressSelected;
                this.trajetJson.addressSelected = iso.addressSelected;
            }
        }

        onClickIsochroneAddress(index: number, item: any) {
            const iso = this.isochrones[index];
            iso.address = item.properties.label;
            iso.addressSelected = item;

            // Seul l'isochrone préféré partage son adresse avec les autres popups
            if (index === this.preferredIsochroneIndex) {
                this.geoJson.address = item.properties.label;
                this.geoJson.addressSelected = item;
                this.transportFilter.addressSelected = item;
                this.trajetJson.addressSelected = item;
            }

            const [lon, lat] = item.geometry.coordinates;
            this.addIsochroneMarker(index, [lon, lat], item.properties.label);
        }

        validateIsoDuration(index: number) {
            let d = this.isochrones[index].duration;
            if (d == null || isNaN(d as any)) d = 5;
            if (d < 5) d = 5;
            if (d > 60) d = 60;
            this.isochrones[index].duration = d;
        }

        async showIsochrones() {
            if (!this.hasAnyIsochroneAddress) return;

            this.addressForm = false;

            // facteur "bus" (Mapbox n'a pas de mode transport en commun)
            const BUS_FACTOR = 0.60;

            const rendered: Array<{ geojson: any; style: object }> = [];
            for (let i = 0; i < this.isochrones.length; i++) {
                const iso = this.isochrones[i];
                if (!iso.addressSelected) continue;

                const [lon, lat] = iso.addressSelected.geometry.coordinates;
                let mode = iso.mode;
                let duration = iso.duration;
                if (mode === 'transit') {
                    mode = 'driving';
                    duration = Math.max(1, Math.floor(duration * BUS_FACTOR));
                }

                const geojson = await this.fetchIsochron({ lng: lon, lat }, { mode, duration });
                const color = this.isochroneColors[i].hex;
                rendered.push({
                    geojson,
                    style: { color, fillColor: color, fillOpacity: 0.15, weight: 2 },
                });
            }

            this.renderedIsochrones = rendered;
            this.rebuildIsochroneMarkers();
            this.fitToIsochrones();
        }

        clearIsochrones() {
            this.renderedIsochrones = [];
            this.removeAllIsochroneMarkers();
            this.isochrones = [{ address: '', addressSelected: null, mode: 'bicycle', duration: 25 }];
            this.activeIsochroneIndex = 0;
            this.preferredIsochroneIndex = 0;
            this.geoJson.address = '';
            this.geoJson.addressSelected = null;
            this.addressForm = false;
        }

        private fitToIsochrones() {
            if (!this.mapInstance) return;
            const pts = this.isochrones
                .filter(iso => iso.addressSelected)
                .map(iso => {
                    const [lon, lat] = iso.addressSelected.geometry.coordinates;
                    return [lat, lon] as [number, number];
                });
            if (!pts.length) return;

            if (pts.length === 1) {
                this.mapInstance.flyTo(pts[0], 13, { duration: 1.5 });
            } else {
                const bounds = L.latLngBounds(pts.map(p => L.latLng(p[0], p[1])));
                this.mapInstance.flyToBounds(bounds, { padding: [60, 60], duration: 1.5, maxZoom: 13 });
            }
        }

        private createIsochronePinIcon(color: string): L.DivIcon {
            return L.divIcon({
                html: `
                    <style>.iso-addr-pulse{animation:isoAddrPulse 2s ease-out infinite}@keyframes isoAddrPulse{0%{transform:translateX(-50%) scale(1);opacity:.45}100%{transform:translateX(-50%) scale(2.2);opacity:0}}</style>
                    <div style="position:relative;width:56px;height:72px;">
                        <div class="iso-addr-pulse" style="position:absolute;width:56px;height:56px;border-radius:50%;top:-4px;left:50%;background:${color};pointer-events:none;"></div>
                        <div style="position:absolute;width:52px;height:52px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);left:50%;top:0;margin-left:-26px;background-color:${color};box-shadow:0 6px 20px rgba(0,0,0,0.45);border:4px solid white;">
                            <div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg);color:white;font-size:20px;">
                                <i class="fas fa-home"></i>
                            </div>
                        </div>
                        <div style="position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:40px;height:10px;background:radial-gradient(ellipse,rgba(0,0,0,0.3) 0%,transparent 70%);border-radius:50%;"></div>
                    </div>
                `,
                className: '',
                iconSize: [56, 72],
                iconAnchor: [28, 72],
                popupAnchor: [0, -72],
            });
        }

        private addIsochroneMarker(index: number, coordinates: [number, number], address: string) {
            this.removeIsochroneMarker(index);
            if (!this.mapInstance) return;

            const color = this.isochroneColors[index % this.isochroneColors.length].hex;
            const [lon, lat] = coordinates;

            const marker = L.marker([lat, lon], { icon: this.createIsochronePinIcon(color) })
                .bindPopup(`
                    <div style="font-size:14px;line-height:1.4;min-width:200px;padding:8px;">
                        <div style="display:flex;align-items:center;margin-bottom:8px;">
                            <div style="width:24px;height:24px;background:${color};border-radius:50%;display:flex;align-items:center;justify-content:center;margin-right:8px;">
                                <i class="fa fa-map-marker" style="color:white;font-size:14px;"></i>
                            </div>
                            <strong style="font-size:1.1em;">Isochrone ${index + 1}</strong>
                        </div>
                        <div style="background:linear-gradient(135deg,#f8f9fa,#e9ecef);padding:8px;border-radius:8px;margin-top:8px;">
                            <i class="fa fa-location-arrow" style="color:${color};margin-right:6px;"></i>
                            ${address}
                        </div>
                    </div>
                `, { maxWidth: 300, className: 'custom-popup' })
                .addTo(this.mapInstance);

            this.isochroneMarkers[index] = marker;
        }

        private removeIsochroneMarker(index: number) {
            const m = this.isochroneMarkers[index];
            if (m && this.mapInstance) this.mapInstance.removeLayer(m);
            this.isochroneMarkers[index] = null;
        }

        private removeAllIsochroneMarkers() {
            this.isochroneMarkers.forEach((m) => {
                if (m && this.mapInstance) this.mapInstance.removeLayer(m);
            });
            this.isochroneMarkers = [];
        }

        // Reconstruit tous les markers d'après les index courants (couleurs alignées)
        private rebuildIsochroneMarkers() {
            this.removeAllIsochroneMarkers();
            this.isochrones.forEach((iso, i) => {
                if (iso.addressSelected) {
                    const [lon, lat] = iso.addressSelected.geometry.coordinates;
                    this.addIsochroneMarker(i, [lon, lat], iso.addressSelected.properties.label);
                }
            });
        }

        // Update deleteTrajetInfo method
        async deleteTrajetInfo() {
            this.isochronGeojson = null;
            this.addressForm = false;
            this.geoJson.address = '';
            this.geoJson.addressSelected = null;
            this.trajetJson.addressProgramme = null;
            
            // Remove address marker
            this.removeAddressMarker();
        }

    formatSuggest(item: any) {
        return item.properties.label
    }

    @Watch('geoJson.address')
    async searchAddress() {
                // ✅ Éviter les appels API avec moins de 3 caractères
                if (!this.geoJson.address || this.geoJson.address.trim().length < 3) {
                    this.result = [];
                    return;
                }
                
                try {
                    const { data } = await getAutocompletion(this.geoJson.address.replace(/ /g, '+'));
                    this.result = data.features;
                } catch (error) {
                    console.warn('❌ Erreur autocomplétion:', error);
                    this.result = [];
                }
            }



    @Watch('trajetJson.address')
    async searchTrajetAddress() {
        //@ts-ignore
        const { data } = await getAutocompletion(this.geoJson.address.replace(/ /g, '+'))
        this.result = data.features;
    
    }


    @Watch('transportFilter.address')
    async searchTransportAddress() {
        //@ts-ignore
        const { data } = await getAutocompletion(this.geoJson.address.replace(/ /g, '+'))
        this.result = data.features;
   
    }


    @Watch('trajetJson.addressProgramme')
        async searchProgrammeAddress() {
        if (!this.trajetJson.addressProgramme) return;

        const { data } = await getAutocompletion(this.trajetJson.addressProgramme.replace(/ /g, '+'));
        this.resultProgramme = data.features;
    }
   



// Add these properties to your component class
markerLoadingInProgress: boolean = false;
private currentLoadId: number = 0;
private denounceCheckInProgress: boolean = false;

@Watch('markers')
async onMarkers(newMarkers: any) {
    if (this.realMarkers.length === newMarkers.length && newMarkers.length > 0) {
        return;
    }

    this.currentLoadId++;
    const thisLoadId = this.currentLoadId;
    this.markerLoadingInProgress = true;

    this.realMarkers = newMarkers;

    await this.$nextTick();

    if (thisLoadId !== this.currentLoadId) return;

    this.buildNativeMarkers();

    this.markerLoadingInProgress = false;
    this.updateVisibleMarkers();
}

private createDivIcon(color: string, isDenounce: boolean, isSelected: boolean): L.DivIcon {
    const bg = isDenounce ? '#1a1a1a' : color;
    const borderColor = isSelected ? '#ffd700' : (isDenounce ? '#fff' : 'white');
    const borderWidth = isSelected ? '4px' : '3px';
    const icon = isDenounce ? 'fa-star' : 'fa-building';
    const denounceLabel = isDenounce
        ? `<div style="position:absolute;bottom:-18px;left:50%;transform:translateX(-50%);background:#1a1a1a;color:white;font-size:9px;font-weight:700;padding:2px 5px;border-radius:4px;white-space:nowrap;letter-spacing:0.5px;">SELECTION</div>`
        : '';
    return L.divIcon({
        html: `
            <div style="position:relative;width:40px;height:52px;">
                <div style="
                    position:absolute;width:40px;height:40px;
                    border-radius:50% 50% 50% 0;transform:rotate(-45deg);
                    left:50%;top:0;margin-left:-20px;
                    background-color:${bg};
                    box-shadow:0 4px 12px rgba(0,0,0,0.4);
                    border:${borderWidth} solid ${borderColor};
                ">
                    <div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg);color:white;font-size:14px;">
                        <i class="fas ${icon}"></i>
                    </div>
                </div>
                ${denounceLabel}
                <div style="position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:30px;height:8px;background:radial-gradient(ellipse,rgba(0,0,0,0.25) 0%,transparent 70%);border-radius:50%;"></div>
            </div>
        `,
        className: '',
        iconSize: [40, 52],
        iconAnchor: [20, 52],
        popupAnchor: [0, -52],
    });
}




private mountPopupComponent(programID: number) {
    this.destroyActivePopup();

    const el = document.getElementById('popup-mount-' + programID);
    if (!el) return;

    const VueClass = Vue2.extend(MapPopup);
    const vm = new VueClass({
        propsData: { programID, opened: true, standalone: true },
        parent: this,
    });
    vm.$mount(el);
    this.activePopupVm = vm;
}

private destroyActivePopup() {
    if (this.activePopupVm) {
        this.activePopupVm.$destroy();
        this.activePopupVm = null;
    }
}




            extraDenounceMarkers: any[] = [];
            denounceIdsReactive: number[] = [];

        get markers() {
            const allMarkers = [...MapModule.markers];
            const denounceIds = this.denounceIds;

            if (denounceIds.length > 0) {
                const presentIds = new Set(allMarkers.map((m: any) => m.programID));
                this.extraDenounceMarkers.forEach((extra: any) => {
                    if (!presentIds.has(extra.programID)) {
                        allMarkers.push(extra);
                    }
                });
            }

            const selectedIds: number[] = ((FiltersModule.filters as any).denounceSelectedProgramIds) || [];
            if (selectedIds.length === 0) return allMarkers;
            return allMarkers.map((marker: any) => {
                if (selectedIds.includes(marker.programID)) {
                    return { ...marker, color: 'gold' };
                }
                return marker;
            });
}


    get mapIsLoading() {
        return MapModule.loading;
    }


    get locationCenter() {
      return MapModule.locationCenter;
    }

    get locationBoundaries() {
      return MapModule.locationBoundaries;
    }

    @Watch('locationCenter')
    onLocationCenterChange(loc: { latitude: number; longitude: number; zoom: number } | null) {
        if (!loc) return;
        const map = (this.$refs.map as any).mapObject as L.Map;
        map.flyTo([loc.latitude, loc.longitude], loc.zoom, { duration: 1.5 });
    }

    @Watch('locationBoundaries')
    onLocationBoundariesChange(boundaries: any) {
        if (!boundaries || !this.mapInstance) return;
        try {
            const layer = L.geoJSON(boundaries);
            const bounds = layer.getBounds();
            if (bounds.isValid()) {
                this.mapInstance.flyToBounds(bounds, { padding: [40, 40], duration: 1.2, maxZoom: 13 });
            }
        } catch (e) { /* ignore invalid bounds */ }
    }




    @Watch('mapIsLoading')
    async onMapIsLoading(isLoading: boolean) {
        if (isLoading) {
             this.loading = true;
            // @ts-ignore
            // this.$vs.loading({
            //     container: this.$refs.container,
            // });
        } else if (this.markers.length === 0) {
             this.loading = false;
            // @ts-ignore
            //this.$vs.loading.close(this.$refs.container);
        }
    }




    zoom = 6;
    center: LeafletPosition = {
        lng: 2.3522,    // France center longitude
        lat: 46.2276,   // France center latitude
    };
    bounds: Bounds | null = null;


    isochronStyle = {
        color: "red",
        fillColor: "red",
        fillOpacity: 0.1
    };




    

    zoomUpdated(zoom: number) {
        this.zoom = zoom;
    }
    centerUpdated(center: LeafletPosition) {
        this.center = center;
    }

    created() {
        this.debouncedBoundsUpdate = debounce(() => {
            // Any logic that should run when bounds change
        }, 300);

        // Autocomplétion des adresses d'isochrones (champ actif)
        this.debouncedIsoSearch = debounce(async (text: string) => {
            if (!text || text.trim().length < 3) {
                this.result = [];
                return;
            }
            try {
                const { data } = await getAutocompletion(text.replace(/ /g, '+'));
                this.result = data.features;
            } catch (error) {
                console.warn('❌ Erreur autocomplétion:', error);
                this.result = [];
            }
        }, 300);

        try {
            const rawIds = localStorage.getItem('denounce_selected_program_ids');
            if (rawIds) this.denounceIdsReactive = JSON.parse(rawIds);
        } catch (e) {}

        try {
            const rawMarkers = localStorage.getItem('denounce_selected_program_markers');
            if (rawMarkers) {
                const savedMarkers = JSON.parse(rawMarkers);
                if (Array.isArray(savedMarkers)) this.extraDenounceMarkers = savedMarkers;
            }
        } catch (e) {}
    }

    boundsUpdated(bounds: Bounds) {
    this.bounds = bounds;
    this.debouncedBoundsUpdate();
    }


    toggleFullscreen() {
        this.pFullscreen = !this.pFullscreen;
    }

    get shownValue() {
        return MapModule.shownValue;
    }

    @Watch('shownValue')
    onShownValue() {
        if (this.shownValue) {
            this.zoom = this.shownValue.zoom;

            setTimeout(() => {
                if (this.shownValue) {
                    this.center = {
                        lng: this.shownValue.longitude,
                        lat: this.shownValue.latitude,
                    };
                }
            }, 1);
        }
    }

    markerReady() {
        if (this.loading) {
            this.loading = false;
        }
    }

    /**
     * Launch retrieval of isochron for a given position
     * @param {LeafletPosition} coordinates Start point coordinates
     * @param {IsochronOptions} options Isochron parameters
     * @param {String} options.mode Routing mode (foot, bicycle, car)
     * @param {Integer} options.duration Maximum routing duration (in minutes, maximum 60 using Mapbox)
     * @returns A GeoJSON feature collection containing isochrone (on promise resolve)
     */
    async fetchIsochron(coordinates: LeafletPosition, options: IsochronOptions) {
        const modeMapbox = options.mode === "foot" ? "mapbox/walking" : (options.mode === "bicycle" ? "mapbox/cycling" : "mapbox/driving");

        return axios.get(`https://api.mapbox.com/isochrone/v1/${modeMapbox}/${coordinates.lng},${coordinates.lat}?contours_minutes=${options.duration}&polygons=true&access_token=${MAPBOX_TOKEN}`)
        .then(response => response.data);
    }





    // ***************************************************************************************************************************************************************
    // ********* Future Transports Functions ************************************************************************************************************

    private futureLineColor(rvb: string): string {
        if (!rvb) return '#764ba2';
        const parts = rvb.split(',').map((v: string) => parseInt(v.trim(), 10));
        if (parts.length === 3 && parts.every((n: number) => !isNaN(n))) {
            return `rgb(${parts[0]},${parts[1]},${parts[2]})`;
        }
        return '#764ba2';
    }

    private futureModeInfo(nomProjet: string): { label: string; icon: string; color: string } {
        const nom = (nomProjet || '').toLowerCase();
        if (/m[eé]tro/.test(nom)) return { label: 'Métro', icon: 'fa-subway', color: '#003D9B' };
        if (/\brer\b|\btrain\b/.test(nom))  return { label: 'RER',   icon: 'fa-train',  color: '#7843A4' };
        if (/tram/.test(nom))               return { label: 'Tram',  icon: 'fa-train',  color: '#E95C0A' };
        return { label: 'Ligne', icon: 'fa-train', color: '#764ba2' };
    }

    private futureLastCoord(geometry: any): [number, number] | null {
        if (!geometry) return null;
        if (geometry.type === 'LineString') {
            const c = geometry.coordinates;
            if (!c || !c.length) return null;
            const last = c[c.length - 1];
            return [last[1], last[0]];
        }
        if (geometry.type === 'MultiLineString') {
            const lines = geometry.coordinates;
            if (!lines || !lines.length) return null;
            const lastLine = lines[lines.length - 1];
            if (!lastLine || !lastLine.length) return null;
            const last = lastLine[lastLine.length - 1];
            return [last[1], last[0]];
        }
        return null;
    }

    get futureTransportsOptions(): object {
        return {
            style: (feature: any) => {
                const p = feature.properties || {};
                // GPE lines carry their color directly; API features use mode-derived color
                const color = (p.source === 'gpe' && p.color) ? p.color : this.futureModeInfo(p.nom_projet).color;
                return {
                    color,
                    weight: 7,
                    opacity: 0.95,
                    lineCap: 'round',
                    lineJoin: 'round',
                };
            },
            onEachFeature: (feature: any, layer: any) => {
                const p = feature.properties || {};
                // GPE lines: gare markers handle all icons/popups — nothing to do here
                if (p.source === 'gpe') return;

                const name  = p.nom_projet || p.indice || 'Ligne en projet';
                const { label: modeLabel, icon: modeIcon, color: col } = this.futureModeInfo(name);

                // Try to parse "... : Départ → Arrivée" from the name
                let from = '';
                let to   = '';
                const arrowIdx = name.indexOf('→');
                if (arrowIdx !== -1) {
                    const colonIdx = name.indexOf(':');
                    from = (colonIdx !== -1 ? name.slice(colonIdx + 1, arrowIdx) : name.slice(0, arrowIdx)).trim();
                    to   = name.slice(arrowIdx + 1).trim();
                }

                const parts = [
                    `<div style="display:flex;align-items:center;margin-bottom:8px;">
                        <div style="
                            width:24px;height:24px;
                            background:${col};
                            border-radius:50%;
                            display:flex;align-items:center;justify-content:center;
                            margin-right:8px;flex-shrink:0;
                        ">
                            <i class="fa ${modeIcon}" style="color:white;font-size:12px;"></i>
                        </div>
                        <strong style="font-size:1.1em;line-height:1.3;">${name}</strong>
                    </div>`,
                    `<div style="
                        background:linear-gradient(135deg,#f8f9fa,#e9ecef);
                        padding:4px 8px;border-radius:12px;
                        display:inline-block;font-size:0.8em;
                        font-weight:500;color:#495057;margin-bottom:8px;
                    ">${modeLabel}</div>`,
                    from ? `<div style="margin:4px 0;">
                        <i class="fa fa-map-marker" style="color:#28a745;margin-right:6px;"></i>
                        <span style="font-weight:500;">Départ :</span> ${from}
                    </div>` : '',
                    to ? `<div style="margin:4px 0;">
                        <i class="fa fa-flag-checkered" style="color:#dc3545;margin-right:6px;"></i>
                        <span style="font-weight:500;">Arrivée :</span> ${to}
                    </div>` : '',
                    `<div style="margin-top:6px;font-size:11px;color:#aaa;border-top:1px solid #eee;padding-top:5px;">
                        Île-de-France Mobilités • En projet
                    </div>`,
                ].filter(Boolean).join('');

                const popupContent = `
                    <div style="font-size:14px;line-height:1.4;min-width:200px;padding:8px;">
                        ${parts}
                    </div>
                `;

                // Place a transport-type icon marker at the end of the trip — popup on icon only
                const endCoord = this.futureLastCoord(feature.geometry);
                if (endCoord && this.mapInstance) {
                    const endIcon = L.divIcon({
                        className: '',
                        html: `<div style="
                            width:30px;height:30px;
                            background:${col};
                            border-radius:50%;
                            border:3px solid #fff;
                            display:flex;align-items:center;justify-content:center;
                            box-shadow:0 3px 10px rgba(0,0,0,0.35);
                            cursor:pointer;
                        "><i class="fa ${modeIcon}" style="color:#fff;font-size:13px;"></i></div>`,
                        iconSize: [30, 30],
                        iconAnchor: [15, 15],
                    });
                    const marker = L.marker(endCoord, { icon: endIcon })
                        .bindPopup(popupContent, { maxWidth: 300, className: 'custom-popup' });
                    marker.addTo(this.mapInstance);
                    this.futureEndMarkers.push(marker);
                }
            },
        };
    }

    onFutureStationsLoaded(geojson: GeoJSON.FeatureCollection<GeoJSON.Geometry>) {
        if (this.mapInstance) {
            this.futureEndMarkers.forEach(m => this.mapInstance!.removeLayer(m));
        }
        this.futureEndMarkers = [];
        this.geojsonFutureTransports = geojson;
        if (this.mapInstance && geojson.features && geojson.features.length > 0) {
            this.mapInstance.flyTo([48.8566, 2.3522], 10, { duration: 1.5 });
        }
    }

    onFutureStationsCleared() {
        this.geojsonFutureTransports = null;
        if (this.mapInstance) {
            this.futureEndMarkers.forEach(m => this.mapInstance!.removeLayer(m));
            this.gpeGareMarkers.forEach(m => this.mapInstance!.removeLayer(m));
        }
        this.futureEndMarkers = [];
        this.gpeGareMarkers = [];
    }

    onGpeStationsLoaded(payload: { gares: any[]; lineColorMap: Record<string, string> }) {
        // Clear previous gare markers
        if (this.mapInstance) {
            this.gpeGareMarkers.forEach(m => this.mapInstance!.removeLayer(m));
        }
        this.gpeGareMarkers = [];

        if (!this.mapInstance || !payload.gares.length) return;

        const { gares, lineColorMap } = payload;

        for (const gare of gares) {
            const nbLines = (gare.line_sgp || []).length;
            const color = gare.primaryColor || '#003D9B';

            // Modern station marker icon
            const badgeHtml = nbLines > 1
                ? `<div style="position:absolute;top:-5px;right:-5px;background:#ff6b35;color:#fff;border-radius:50%;width:15px;height:15px;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;border:1.5px solid #fff;line-height:1;">${nbLines}</div>`
                : '';

            const icon = L.divIcon({
                className: '',
                html: `<div style="position:relative;width:34px;height:34px;background:#fff;border:3px solid ${color};border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(0,0,0,0.28),0 0 0 2px rgba(255,255,255,0.7);cursor:pointer;transition:transform 0.15s;"
                    onmouseover="this.style.transform='scale(1.18)'" onmouseout="this.style.transform='scale(1)'">
                    <i class="fa fa-subway" style="color:${color};font-size:14px;"></i>
                    ${badgeHtml}
                </div>`,
                iconSize: [34, 34],
                iconAnchor: [17, 17],
                popupAnchor: [0, -20],
            });

            const marker = L.marker([gare.lat, gare.lon], { icon });

            // Lazy popup: content is generated only when the popup first opens
            let cachedContent: string | null = null;
            marker.bindPopup(() => {
                if (cachedContent) return cachedContent;

                const linesHtml = (gare.line_sgp || []).map((l: string) => {
                    const lc = lineColorMap[l] || '#667eea';
                    return `<span style="background:${lc};color:#fff;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block;margin:2px;">${l}</span>`;
                }).join('');

                const metroHtml = (gare.line_metro || []).map((m: string) =>
                    `<span style="background:#003D9B;color:#fff;padding:2px 8px;border-radius:20px;font-size:11px;font-weight:600;display:inline-block;margin:2px;">${m}</span>`
                ).join('');

                cachedContent = `
                    <div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;min-width:230px;padding:4px;">
                        <div style="display:flex;align-items:flex-start;gap:10px;margin-bottom:12px;">
                            <div style="background:${color};border-radius:12px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 4px 12px ${color}66;">
                                <i class="fa fa-subway" style="color:#fff;font-size:17px;"></i>
                            </div>
                            <div>
                                <div style="font-size:15px;font-weight:700;color:#1a1a2e;line-height:1.2;">${gare.name}</div>
                                ${gare.subtitle ? `<div style="font-size:11px;color:#888;margin-top:2px;">${gare.subtitle}</div>` : ''}
                                <div style="font-size:10px;color:#bbb;margin-top:3px;">Grand Paris Express</div>
                            </div>
                        </div>

                        <div style="margin-bottom:10px;">
                            <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.7px;color:#667eea;margin-bottom:6px;">Lignes en projet</div>
                            <div style="display:flex;flex-wrap:wrap;gap:0;">${linesHtml || '<span style="color:#aaa;font-size:12px;">–</span>'}</div>
                        </div>

                        ${gare.line_metro && gare.line_metro.length > 0 ? `
                        <div style="margin-bottom:8px;">
                            <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.7px;color:#888;margin-bottom:6px;">Correspondances actuelles</div>
                            <div style="display:flex;flex-wrap:wrap;gap:0;">${metroHtml}</div>
                        </div>` : ''}

                        <div style="font-size:10px;color:#ccc;border-top:1px solid #f0f0f0;padding-top:6px;margin-top:4px;">
                            Société du Grand Paris • Île-de-France Mobilités
                        </div>
                    </div>`;
                return cachedContent;
            }, { maxWidth: 300, className: 'custom-popup' });

            marker.addTo(this.mapInstance);
            this.gpeGareMarkers.push(marker);
        }
    }

    // ***************************************************************************************************************************************************************
    // ********* Transport Functions **********************************************************************************************************



            transportErrorMessage: String = '';



                                // FUNCTION 2: Replace your transformToGeoJson() method with this:
                transformToGeoJson(data: any): GeoJSON.FeatureCollection<GeoJSON.Geometry> {
                    const features: GeoJSON.Feature[] = [];
                    
                    data.elements
                        .filter((el: any) => el.type === 'relation' && el.members)
                        .forEach((relation: any) => {
                            // Get all way members that have geometry
                            const wayMembers = relation.members.filter((member: any) => 
                                member.type === 'way' && member.geometry && Array.isArray(member.geometry)
                            );
                            
                            if (wayMembers.length === 0) return;
                            
                            const coordinates = wayMembers.map((member: any) => 
                                member.geometry.map((pt: any) => [pt.lon, pt.lat])
                            );
                            
                            // Find terminus station coords from ordered stop-role node members
                            const stopRoles = ['stop', 'stop_entry_only', 'stop_exit_only'];
                            const stopNodes = (relation.members || []).filter((m: any) =>
                                m.type === 'node' && stopRoles.indexOf(m.role) !== -1 && m.lat != null
                            );
                            const firstStop = stopNodes.length > 0 ? stopNodes[0] : null;
                            const lastStop = stopNodes.length > 1 ? stopNodes[stopNodes.length - 1] : null;

                            features.push({
                                type: 'Feature',
                                geometry: {
                                    type: 'MultiLineString',
                                    coordinates: coordinates
                                },
                                properties: {
                                    id: relation.id,
                                    ref: relation.tags && relation.tags.ref ? relation.tags.ref : 'Unknown',
                                    name: relation.tags && relation.tags.name ? relation.tags.name : 'Unnamed line',
                                    route: relation.tags && relation.tags.route ? relation.tags.route : relation.transportMode,
                                    colour: relation.tags && relation.tags.colour ? relation.tags.colour : '#FF0000',
                                    from: relation.tags && relation.tags.from ? relation.tags.from : '',
                                    to: relation.tags && relation.tags.to ? relation.tags.to : '',
                                    transportMode: relation.transportMode,
                                    // Actual terminus station coordinates from OSM stop members
                                    fromLat: firstStop ? firstStop.lat : null,
                                    fromLon: firstStop ? firstStop.lon : null,
                                    toLat: lastStop ? lastStop.lat : null,
                                    toLon: lastStop ? lastStop.lon : null,
                                }
                            });
                        });

                    this.assignUniqueColors(features);
                    
                    return {
                        type: 'FeatureCollection',
                        features
                    };
                }

                // FUNCTION 3: Replace your assignUniqueColors() method with this:
                private assignUniqueColors(features: GeoJSON.Feature[]): void {
                          
                    const used = new Set<string>();
                            const map = this.mapInstance!; 

                            features.forEach(f => {
                                const props = (f.properties as any);
                                const from = props.from as string;
                                const to   = props.to   as string;

                                // skip any line that has NO departure AND NO arrival
                                if (!from && !to) {
                                    return;
                                }

                                // Prefer OSM colour tag; fall back to a unique random color
                                let col: string;
                                if (props.colour && props.colour.startsWith('#')) {
                                    col = props.colour;
                                } else {
                                    do {
                                        col = this.getRandomColor();
                                    } while (used.has(col));
                                }
                                used.add(col);
                                props.randomColor = col;

                                // Enhanced icon styling by mode
                                const mode = props.transportMode || props.route || '';
                                let iconClass = 'fa-subway';
                                let iconColor = '#2196F3';
                                let shadowColor = 'rgba(33, 150, 243, 0.3)';

                                if (mode === 'tram') {
                                    iconClass = 'fa-tram';
                                    iconColor = '#FF6B6B';
                                    shadowColor = 'rgba(255, 107, 107, 0.3)';
                                } else if (mode === 'subway') {
                                    iconClass = 'fa-subway';
                                    iconColor = '#4ECDC4';
                                    shadowColor = 'rgba(78, 205, 196, 0.3)';
                                } else if (mode === 'RER') {
                                    iconClass = 'fa-train';
                                    iconColor = '#45B7D1';
                                    shadowColor = 'rgba(69, 183, 209, 0.3)';
                                } else if (mode === 'bus') {
                                    iconClass = 'fa-bus';
                                    iconColor = '#96CEB4';
                                    shadowColor = 'rgba(150, 206, 180, 0.3)';
                                }

                                // Build terminus positions from OSM stop-node members stored in properties.
                                // Fall back to geometry only if no stop nodes were found.
                                const terminusPositions: Array<{ pos: [number, number]; label: string }> = [];
                                if (props.fromLat != null && props.fromLon != null) {
                                    terminusPositions.push({ pos: [props.fromLat, props.fromLon], label: from || 'Départ' });
                                }
                                if (props.toLat != null && props.toLon != null) {
                                    const isDifferent = props.fromLat !== props.toLat || props.fromLon !== props.toLon;
                                    if (isDifferent) {
                                        terminusPositions.push({ pos: [props.toLat, props.toLon], label: to || 'Arrivée' });
                                    }
                                }
                                if (terminusPositions.length === 0) {
                                    const fallback = this.getLineTerminus(f);
                                    terminusPositions.push({ pos: fallback, label: from || props.name || props.ref });
                                }

                                const makeTerminusIcon = (isFrom: boolean) => new L.DivIcon({
                                    html: '<div style="' +
                                        'position:relative;width:48px;height:48px;' +
                                        'background:#fff;' +
                                        'border:4px solid ' + col + ';' +
                                        'border-radius:50%;' +
                                        'display:flex;align-items:center;justify-content:center;' +
                                        'box-shadow:0 4px 16px ' + shadowColor + ',0 0 0 3px rgba(255,255,255,0.8);' +
                                        'cursor:pointer;' +
                                    '">' +
                                        '<i class="fa ' + iconClass + '" style="color:' + col + ';font-size:18px;"></i>' +
                                        '<div style="' +
                                            'position:absolute;top:-3px;right:-3px;' +
                                            'width:16px;height:16px;' +
                                            'background:' + (isFrom ? '#28a745' : '#dc3545') + ';' +
                                            'border:2.5px solid white;border-radius:50%;' +
                                            'box-shadow:0 1px 4px rgba(0,0,0,0.3);' +
                                        '"></div>' +
                                    '</div>',
                                    iconSize: [48, 48],
                                    iconAnchor: [24, 24],
                                    className: 'custom-transport-icon'
                                });

                                const popupContent = '<div style="font-size:14px;line-height:1.4;min-width:200px;padding:8px;">' +
                                    '<div style="display:flex;align-items:center;margin-bottom:8px;">' +
                                        '<div style="width:28px;height:28px;background:' + col + ';border-radius:50%;display:flex;align-items:center;justify-content:center;margin-right:8px;flex-shrink:0;">' +
                                            '<i class="fa ' + iconClass + '" style="color:white;font-size:13px;"></i>' +
                                        '</div>' +
                                        '<strong style="font-size:1.05em;">' + (props.name || props.ref) + '</strong>' +
                                    '</div>' +
                                    (mode ? '<div style="background:#f0f0f0;padding:3px 8px;border-radius:10px;display:inline-block;font-size:0.78em;font-weight:600;color:#555;margin-bottom:8px;">' + mode.toUpperCase() + '</div>' : '') +
                                    (from ? '<div style="margin:4px 0;"><i class="fa fa-map-marker" style="color:#28a745;margin-right:6px;"></i><span style="font-weight:500;">Départ :</span> ' + from + '</div>' : '') +
                                    (to ? '<div style="margin:4px 0;"><i class="fa fa-flag-checkered" style="color:#dc3545;margin-right:6px;"></i><span style="font-weight:500;">Arrivée :</span> ' + to + '</div>' : '') +
                                '</div>';

                                terminusPositions.forEach((t, idx) => {
                                    const icon = makeTerminusIcon(idx === 0);
                                    const marker = L.marker(t.pos, { icon })
                                        .bindPopup(popupContent, { maxWidth: 300, className: 'custom-popup' })
                                        .addTo(map);
                                    this.transportMarkers.push(marker);
                                });
                            });
                        }

                        // Enhanced train stations method with better styling
                        private async loadTrainStations(lat: number, lon: number, radiusKm: number): Promise<void> {
                            const meters = radiusKm * 1000;
                            const query =
                                '[out:json][timeout:25];' +
                                'node["railway"="station"](around:' + meters + ',' + lat + ',' + lon + ');' +
                                'out;';
                            try {
                                const res = await fetch('https://overpass-api.de/api/interpreter', {
                                    method: 'POST',
                                    body: query
                                });
                                const data = await res.json();
                                const elems: any[] = data.elements || [];
                                
                                elems
                                    .filter(el => el.type === 'node' && el.tags && el.tags.name)
                                    .forEach(node => {
                                        // Enhanced train station icon
                                        const stationIcon = new L.DivIcon({
                                            html: `
                                                <div class="train-station-marker" style="
                                                    position: relative;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    width: 50px;
                                                    height: 50px;
                                                    background: linear-gradient(135deg, #FF9800, #F57C00);
                                                    border: 2px solid white;
                                                    border-radius: 8px;
                                                    box-shadow: 0 3px 10px rgba(255, 152, 0, 0.4), 0 0 0 1px rgba(0,0,0,0.1);
                                                    transition: all 0.3s ease;
                                                    cursor: pointer;
                                                ">
                                                    <i class="fa fa-train" style="
                                                        color: white;
                                                        font-size: 14px;
                                                        text-shadow: 0 1px 2px rgba(0,0,0,0.3);
                                                    "></i>
                                                    <!-- Station indicator -->
                                                    <div style="
                                                        position: absolute;
                                                        top: -4px;
                                                        right: -4px;
                                                        width: 12px;
                                                        height: 12px;
                                                        background: #4CAF50;
                                                        border: 1px solid white;
                                                        border-radius: 50%;
                                                    "></div>
                                                </div>
                                                <style>
                                                    .train-station-marker:hover {
                                                        transform: scale(1.1);
                                                        box-shadow: 0 5px 15px rgba(255, 152, 0, 0.5), 0 0 0 1px rgba(0,0,0,0.2);
                                                    }
                                                </style>
                                            `,
                                            iconSize: [32, 32],
                                            iconAnchor: [16, 16],
                                            className: 'custom-station-icon'
                                        });

                                        const marker = L.marker([node.lat, node.lon], { icon: stationIcon })
                                            .bindPopup(`
                                                <div style="
                                                    font-size: 14px;
                                                    line-height: 1.4;
                                                    min-width: 180px;
                                                    padding: 8px;
                                                ">
                                                    <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                                        <div style="
                                                            width: 24px; height: 24px;
                                                            background: linear-gradient(135deg, #FF9800, #F57C00);
                                                            border-radius: 6px;
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            margin-right: 8px;
                                                        ">
                                                            <i class="fa fa-train" style="color: white; font-size: 12px;"></i>
                                                        </div>
                                                        <strong style="font-size: 1.1em;">${node.tags.name}</strong>
                                                    </div>
                                                    <div style="
                                                        background: linear-gradient(135deg, #fff3e0, #ffe0b2);
                                                        padding: 4px 8px;
                                                        border-radius: 12px;
                                                        display: inline-block;
                                                        font-size: 0.8em;
                                                        font-weight: 500;
                                                        color: #e65100;
                                                    ">GARE FERROVIAIRE</div>
                                                </div>
                                            `, {
                                                maxWidth: 300,
                                                className: 'custom-popup'
                                            })
                                            .addTo(this.mapInstance!);
                                            
                                        this.transportMarkers.push(marker);
                                    });
                            } catch (e) {
                                console.warn('Train-station fetch failed', e);
                            }
                        }

                        private loadStopsFromElements(elements: any[], modes: Record<string, boolean>): void {
                            const stopRoles = ['stop', 'stop_entry_only', 'stop_exit_only'];
                            const seen = new Set<number>();

                            // Pre-build set of terminus node refs — these already have bigger terminus markers
                            // so we must not place a duplicate stop marker on top of them
                            const terminusRefs = new Set<number>();
                            for (const el of elements) {
                                if (el.type !== 'relation' || !el.tags || !el.members) continue;
                                const r = el.tags.route || '';
                                const net = el.tags.network || '';
                                const netRef = el.tags.network_ref || '';
                                const isS = r === 'subway' && modes.subway;
                                const isR = (net.indexOf('RER') !== -1 || netRef === 'RER') && modes.train;
                                const isT = r === 'tram' && modes.tram;
                                const isTr = (r === 'train' || r === 'rail') && modes.train;
                                if (!isS && !isR && !isT && !isTr) continue;
                                const sn = el.members.filter((m: any) =>
                                    m.type === 'node' && stopRoles.indexOf(m.role) !== -1 && m.lat != null
                                );
                                if (sn.length > 0) terminusRefs.add(sn[0].ref);
                                if (sn.length > 1) terminusRefs.add(sn[sn.length - 1].ref);
                            }

                            for (const el of elements) {
                                if (el.type !== 'relation' || !el.tags || !el.members) continue;

                                const route = el.tags.route || '';
                                const network = el.tags.network || '';
                                const networkRef = el.tags.network_ref || '';

                                const isSubway = route === 'subway' && modes.subway;
                                const isRER = (network.indexOf('RER') !== -1 || networkRef === 'RER') && modes.train;
                                const isTram = route === 'tram' && modes.tram;
                                const isTrain = (route === 'train' || route === 'rail') && modes.train;

                                if (!isSubway && !isRER && !isTram && !isTrain) continue;

                                const rawColor = el.tags.colour || '';
                                const color = rawColor.startsWith('#') ? rawColor
                                    : isSubway ? '#003D9B'
                                    : isTram   ? '#E95C0A'
                                    : '#7843A4';

                                const stopIconClass = isSubway ? 'fa-subway' : 'fa-train';
                                const lineRef = el.tags.ref || '';
                                const lineName = el.tags.name || lineRef || 'Ligne';

                                for (const m of el.members) {
                                    if (m.type !== 'node') continue;
                                    if (stopRoles.indexOf(m.role) === -1) continue;
                                    if (terminusRefs.has(m.ref)) continue; // terminus marker already placed
                                    if (seen.has(m.ref)) continue;
                                    if (m.lat == null) continue;
                                    seen.add(m.ref);

                                    const stopName = m.nodeTags && m.nodeTags.name ? m.nodeTags.name : '';

                                    const stopIcon = new L.DivIcon({
                                        html: '<div style="' +
                                            'width:24px;height:24px;' +
                                            'background:#fff;' +
                                            'border:3px solid ' + color + ';' +
                                            'border-radius:50%;' +
                                            'display:flex;align-items:center;justify-content:center;' +
                                            'box-shadow:0 2px 8px rgba(0,0,0,0.28);' +
                                            'cursor:pointer;' +
                                        '">' +
                                            '<i class="fa ' + stopIconClass + '" style="color:' + color + ';font-size:9px;"></i>' +
                                        '</div>',
                                        iconSize: [24, 24],
                                        iconAnchor: [12, 12],
                                        className: ''
                                    });

                                    const popupHtml =
                                        '<div style="font-size:13px;line-height:1.5;min-width:150px;padding:4px;">' +
                                        '<div style="display:flex;align-items:center;gap:7px;margin-bottom:5px;">' +
                                        '<div style="background:' + color + ';color:white;font-weight:700;' +
                                            'font-size:0.85em;padding:2px 7px;border-radius:5px;flex-shrink:0;">' +
                                            lineRef +
                                        '</div>' +
                                        (stopName
                                            ? '<strong style="color:#1a1a2e;">' + stopName + '</strong>'
                                            : '<span style="color:#555;">' + lineName + '</span>'
                                        ) +
                                        '</div>' +
                                        '<span style="font-size:0.78em;color:#888;">' +
                                            (stopName ? lineName + ' · Arrêt' : 'Arrêt') +
                                        '</span>' +
                                        '</div>';

                                    const marker = L.marker([m.lat, m.lon], { icon: stopIcon })
                                        .bindPopup(popupHtml, { maxWidth: 260, className: 'custom-popup' })
                                        .addTo(this.mapInstance!);

                                    this.transportMarkers.push(marker);
                                }
                            }
                        }

                        // Helper method to darken colors
                        private darkenColor(color: string, percent: number): string {
                            const num = parseInt(color.replace("#", ""), 16);
                            const amt = Math.round(2.55 * percent);
                            const R = (num >> 16) - amt;
                            const G = (num >> 8 & 0x00FF) - amt;
                            const B = (num & 0x0000FF) - amt;
                            return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
                                (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
                                (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
                        }




                            // ── TransportLinesPopup event handlers ──────────────────────────────────

                        onTransportAddressSelected(item: any) {
                            this.geoJson.address = item.properties.label;
                            this.geoJson.addressSelected = item;
                            this.transportFilter.addressSelected = item;
                            const [lon, lat] = item.geometry.coordinates;
                            this.addAddressMarker([lon, lat], item.properties.label);
                        }

                        async onTransportLinesApply(payload: {
                            elements: any[];
                            lat: number;
                            lon: number;
                            radius: number;
                            modes: Record<string, boolean>;
                        }) {
                            this.clearTransportMarkers();
                            this.transportInFlight = true;

                            const { elements, lat, lon, radius, modes } = payload;

                            if (this.mapInstance) {
                                this.mapInstance.flyTo([lat, lon], 12, { duration: 1.5 });
                            }

                            if (!elements.length) {
                                this.transportErrorForm = true;
                                this.transportInFlight = false;
                                return;
                            }

                            try {
                                this.geojsonTransport = this.transformToGeoJson({ elements });

                                if (modes.subway || modes.tram || modes.train) {
                                    this.loadStopsFromElements(elements, modes);
                                }
                            } catch (err) {
                                console.error('onTransportLinesApply error:', err);
                                this.transportErrorForm = true;
                            } finally {
                                this.transportInFlight = false;
                            }
                        }

                        // 4) Don't forget to clear station markers along with lines
                            public clearTrajets() {
                                this.geojsonTransport = null;
                                this.transportMarkers.forEach(m => m.remove());
                                this.transportMarkers = [];
                                this.transportErrorForm = false;

                                this.transportFilter.address = '';
                                this.transportFilter.addressSelected = null;
                                Object.keys(this.transportFilter.modes).forEach((k: any) => {
                                    (this.transportFilter.modes as any)[k] = false;
                                });
                                
                                // Remove address marker
                                this.removeAddressMarker();
                            }




            clearTransportMarkers() {
                this.transportMarkers.forEach(m => {
                    m.remove();
                  
                });
                this.transportMarkers = [];
                this.geojsonTransport = null;
                this.transportInFlight = false;
                
                if ((window as any).gc) (window as any).gc();
            }





// Add this method to your component
onTransportLayerReady() {
    console.log('Transport layer is ready and should be visible on map');
    
    // Optional: Fit the map to show all transport lines
    if (this.geojsonTransport && this.geojsonTransport.features.length > 0) {
        // @ts-ignore
        const map = this.$refs.map.mapObject;
        
        // Calculate bounds of all features
        let bounds: any = null;
        this.geojsonTransport.features.forEach((feature: any) => {
            if (feature.geometry.type === 'MultiLineString') {
                feature.geometry.coordinates.forEach((lineString: any) => {
                    lineString.forEach((coord: any) => {
                        if (!bounds) {
                            bounds = [[coord[1], coord[0]], [coord[1], coord[0]]];
                        } else {
                            if (coord[1] < bounds[0][0]) bounds[0][0] = coord[1];
                            if (coord[0] < bounds[0][1]) bounds[0][1] = coord[0];
                            if (coord[1] > bounds[1][0]) bounds[1][0] = coord[1];
                            if (coord[0] > bounds[1][1]) bounds[1][1] = coord[0];
                        }
                    });
                });
            }
        });
        
        if (bounds && map) {
            map.fitBounds(bounds, { padding: [20, 20] });
        }
    }
}




getTransportStyle(feature: any) {
    return {
        color: feature.properties.randomColor,
        weight: 10,
        opacity: 0.92,
        lineCap: 'round',
        lineJoin: 'round'
    };
}

getLocationBoundaryStyle(feature: any) {
    const type = feature && feature.properties && feature.properties.locationType;
    switch (type) {
        case 'region':
            return { color: '#1d4ed8', weight: 4, opacity: 1, fillColor: '#3b82f6', fillOpacity: 0.18, dashArray: '8 5' };
        case 'department':
            return { color: '#b45309', weight: 3.5, opacity: 1, fillColor: '#f59e0b', fillOpacity: 0.22, dashArray: '6 4' };
        case 'city':
            return { color: '#047857', weight: 3, opacity: 1, fillColor: '#10b981', fillOpacity: 0.28 };
        default:
            return { color: '#4338ca', weight: 3, opacity: 1, fillColor: '#6366f1', fillOpacity: 0.18 };
    }
}


validateDuration() {
    // Ensure the value stays within bounds
    if (this.geoJson.duration < 1) {
        this.geoJson.duration = 5;
    } else if (this.geoJson.duration > 60) {
        this.geoJson.duration = 60;
    }
}




// **********************   Coloring the Result ***************************
/**
 * Generate a random hex color string, e.g. "#A1B2C3"
 */
 private getRandomColor(): string {
  return (
    "#" +
    Math.floor(Math.random() * 0xFFFFFF)
      .toString(16)
      .padStart(6, "0")
      .toUpperCase()
  );
}

            /**
             * After building your features, assign each a unique random color.
             */
            /**
             * After building your features, assign each a unique random color,
             * then place a little marker at that line's terminus (with a popup showing its name).
             */
            private getLineTerminus(feature: GeoJSON.Feature, flip = false): [number, number] {
                // The feature.geometry here is a MultiLineString: an array of arrays of [lon,lat]
                const lines = (feature.geometry as any).coordinates as [number, number][][];
                // pick the first line or last if flip=true
                const line = flip ? lines[lines.length - 1] : lines[0];
                // then pick its first point or last if flip=true
                const pt = flip ? line[line.length - 1] : line[0];
                // return [lat, lon]
                return [pt[1], pt[0]];
            }







            // New Filters Design **********************************************************************
        showFilterPopup: boolean = false;

        openFilterPopup() {
            this.showFilterPopup = true;
        }

        onFiltersApplied() {
            MapModule.fetch();
            MapModule.fetchLocationBoundaries();
            this.$emit('filtersChanged');
        }




           // Addresse MArker **********************************************************************
                addressMarker: L.Marker | null = null;

            

                // Add this method in your methods section
            private addAddressMarker(coordinates: [number, number], address: string) {
                // Remove existing marker if any
                this.removeAddressMarker();
                
                if (!this.mapInstance) return;
                
                const [lon, lat] = coordinates;
                
                // Create a custom red marker icon (similar to the one in your image)
                const redIcon = new L.Icon({
                    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
                    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
                        iconSize: [75, 123],      // 3x bigger (was [25, 41])
                        iconAnchor: [37, 123],    // 3x bigger (was [12, 41])
                        popupAnchor: [1, -102],   // Adjusted for bigger icon (was [1, -34])
                        shadowSize: [100, 100] 
                });
                
                // Create marker
                this.addressMarker = L.marker([lat, lon], { icon: redIcon })
                    .bindPopup(`
                        <div style="
                            font-size: 14px;
                            line-height: 1.4;
                            min-width: 200px;
                            padding: 8px;
                        ">
                            <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                <div style="
                                    width: 24px; height: 24px;
                                    background: #dc3545;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin-right: 8px;
                                ">
                                    <i class="fa fa-map-marker" style="color: white; font-size: 14px;"></i>
                                </div>
                                <strong style="font-size: 1.1em;">Adresse Idéale</strong>
                            </div>
                            <div style="
                                background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                                padding: 8px;
                                border-radius: 8px;
                                margin-top: 8px;
                            ">
                                <i class="fa fa-location-arrow" style="color: #dc3545; margin-right: 6px;"></i>
                                ${address}
                            </div>
                        </div>
                    `, {
                        maxWidth: 300,
                        className: 'custom-popup'
                    })
                    .addTo(this.mapInstance);
            }

            private removeAddressMarker() {
                if (this.addressMarker && this.mapInstance) {
                    this.mapInstance.removeLayer(this.addressMarker);
                    this.addressMarker = null;
                }
            }

           beforeDestroy() {
                this.destroyActivePopup();
                this.removeAddressMarker();
                this.removeAllIsochroneMarkers();
                this.clearTransportMarkers();
                this.clearTrajets();
                this.nativeMarkersMap.clear();
                if (this.denounceLayerGroup) {
                    if (this.mapInstance) this.mapInstance.removeLayer(this.denounceLayerGroup);
                    this.denounceLayerGroup = null;
                }
                if (this.mapInstance) {
                    this.mapInstance.remove();
                }
                this.realMarkers = [];
                this.visibleMarkers = [];
                MapModule.setMarkers([]);
            }




            get hasDenounceSelection(): boolean {
                    return this.denounceIds.length > 0;
                }



                clearDenounceSelection() {
                    const $vs = (this as any).$vs;

                    $vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmer la suppression',
                        text: 'Etes-vous sur de vouloir supprimer tous les programmes selectionnes pour denonciation ?',
                        accept: () => {
                            localStorage.removeItem('denounce_selected_program_ids');
                            localStorage.removeItem('denounce_selected_lot_ids');
                            localStorage.removeItem('denounce_selected_program_markers');
                            sessionStorage.removeItem('denounce_session_active');
                            this.denounceIdsReactive = [];
                            this.extraDenounceMarkers = [];
                            this.buildNativeMarkers();

                            $vs.notify({
                                color: 'success',
                                position: 'top-right',
                                title: 'Suppression reussie',
                                text: 'Les programmes selectionnes ont ete supprimes',
                            });
                        }
                    });
                }


 
                

                denounceWarningVisible: boolean = false;
                denounceWarningItems: { type: 'program' | 'lot'; id: number; name: string }[] = [];


                private buildNativeMarkers() {
                        const map = this.mapInstance;
                        if (!map) return;

                        const clusterRef = this.$refs.clusterGroup as any;
                        const clusterLayer = clusterRef && clusterRef.mapObject ? clusterRef.mapObject : null;

                        if (clusterLayer) {
                            clusterLayer.clearLayers();
                        }

                        if (this.denounceLayerGroup) {
                            this.denounceLayerGroup.clearLayers();
                        } else {
                            this.denounceLayerGroup = L.layerGroup().addTo(map);
                        }

                        this.nativeMarkersMap.clear();

                        const denounceIds = this.denounceIds;
                        const bookmarkedIds = new Set(
                            (ListModule.programsBookmarked || []).map((p: any) => p.id)
                        );

                        this.realMarkers.forEach((markerData: any) => {
                            const { programID, coordinates, color } = markerData;
                            if (!coordinates) return;

                            const isDenounce = denounceIds.includes(programID);
                            const isSelected = bookmarkedIds.has(programID);
                            const icon = this.createDivIcon(color || '#4CAF50', isDenounce, isSelected);

                            const lMarker = L.marker([coordinates.lat, coordinates.lng], { icon });

                            lMarker.bindPopup('<div id="popup-mount-' + programID + '"></div>', {
                                maxWidth: 280,
                                minWidth: 280,
                                className: 'custom-popup',
                            });

                            lMarker.on('popupopen', () => {
                                this.$nextTick(() => {
                                    this.mountPopupComponent(programID);
                                });
                            });

                            lMarker.on('popupclose', () => {
                                this.destroyActivePopup();
                            });

                            this.nativeMarkersMap.set(programID, lMarker);

                            if (isDenounce) {
                                this.denounceLayerGroup!.addLayer(lMarker);
                            } else if (clusterLayer) {
                                clusterLayer.addLayer(lMarker);
                            } else {
                                lMarker.addTo(map);
                            }
                        });

                        this.loading = false;
                        this.checkDenounceSelectionValidity();
                    }



                private async checkDenounceSelectionValidity() {
                    if (this.denounceCheckInProgress) return;
                    const denounceIds = this.denounceIds;
                    if (denounceIds.length === 0) return;
                    this.denounceCheckInProgress = true;

                    try {
                        const presentProgramIds = new Set(this.realMarkers.map((m: any) => m.programID));
                        const missingProgramIds = denounceIds.filter((id: number) => !presentProgramIds.has(id));

                        if (missingProgramIds.length === 0) return;

                        // Try to fetch coordinates for programs missing from the map (filtered out or no saved coords)
                        const coveredByExtra = new Set(this.extraDenounceMarkers.map((m: any) => m.programID));
                        const needFetch = missingProgramIds.filter((id: number) => !coveredByExtra.has(id));

                        if (needFetch.length > 0) {
                            const fetched: any[] = [];
                            for (const id of needFetch) {
                                try {
                                    const { data } = await getProgramPrescriber(id);
                                    const addr = data && data.address;
                                    if (addr && addr.latitude && addr.longitude) {
                                        fetched.push({
                                            programID: id,
                                            coordinates: { lat: addr.latitude, lng: addr.longitude },
                                            color: '#1a1a1a',
                                        });
                                    }
                                } catch (e) {}
                            }
                            if (fetched.length > 0) {
                                this.extraDenounceMarkers = [
                                    ...this.extraDenounceMarkers,
                                    ...fetched.filter(f => !coveredByExtra.has(f.programID)),
                                ];
                                try {
                                    localStorage.setItem('denounce_selected_program_markers', JSON.stringify(this.extraDenounceMarkers));
                                } catch (e) {}
                                // Sync realMarkers with the updated markers computed value, then re-render
                                this.realMarkers = this.markers;
                                this.denounceCheckInProgress = false;
                                this.buildNativeMarkers();
                                return;
                            }
                        }
                    } finally {
                        this.denounceCheckInProgress = false;
                    }
                }




 
                
            }
